export default __webpack_public_path__ + "8295e85828c12c5391b8700e275665c4.png";